export const printablePlanRetargetingBrazeAttributes = [
	{
		matcher: {
			printable_plan_retargeting: true,
		},
		events: [
			{
				name: 'printable_plan_subscription_purchased',
			},
		],
	},
]
